import React from "react";
import { t } from "@client/lib/dictionary";
import type { BmsAlarmFlags } from "@client/types/bms";

interface Props {
  alarms: BmsAlarmFlags | undefined;
}

const labels: Record<keyof Omit<BmsAlarmFlags, "raw">, string> = {
  cellOverVoltage: "Cell OVP",
  cellUnderVoltage: "Cell UVP",
  packOverVoltage: "Pack OVP",
  packUnderVoltage: "Pack UVP",
  chargeOverTemp: "Charge OT",
  chargeUnderTemp: "Charge UT",
  dischargeOverTemp: "Discharge OT",
  mosOverTemp: "MOS OT",
  cellImbalance: "Imbalance",
  chargeOverCurrent: "Charge OCP",
  dischargeOverCurrent: "Discharge OCP",
  shortCircuit: "Short circuit",
};

export const BmsAlarmsBar: React.FC<Props> = ({ alarms }) => {
  if (!alarms) return null;
  const active = (Object.keys(labels) as Array<keyof typeof labels>).filter((k) => alarms[k]);
  if (active.length === 0) {
    return (
      <div className="inline-flex items-center gap-2 rounded px-3 py-1.5 bg-green-50 dark:bg-green-950 text-green-700 dark:text-green-300 text-sm">
        <span className="size-2 rounded-full bg-current" />
        {t.bms.noAlarms}
      </div>
    );
  }
  return (
    <div className="flex flex-wrap gap-2">
      {active.map((key) => (
        <span
          key={key}
          className="inline-flex items-center gap-1.5 rounded px-2.5 py-1 bg-red-600 text-white text-xs font-medium"
        >
          <span className="size-1.5 rounded-full bg-current" />
          {labels[key]}
        </span>
      ))}
    </div>
  );
};
